import { lazy } from 'react';

export default [
    {
        path: '/temple-exhibition',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'TempleExhibitionLayout' */ './layout')),
    },
];
